module.exports = __webpack_public_path__ + "img/pro-forma-invoice.5c220177.svg";